export default __webpack_public_path__ + "static/media/magento.d7fa1143.svg";